import React from 'react';
import { getCategoryConfig } from '../CategoryConfig';
import { CTooltip } from '@coreui/react';

const SubFilterProgressBar = ({ data, mapFilter }) => {
  const colors = ['#5856D6', '#3399FF', '#2EB85C', '#F9B115', '#E55353', '#AF7AC5', '#5D6D7E'];

  const getChartData = () => {
    let segments = [];
    if (!mapFilter || mapFilter === 'all' || !data) return segments;

    const config = getCategoryConfig(mapFilter);
    let total = 0;
    
    const calculatedSegments = config.subFilters.map(sub => {
      let count = 0;
      data.forEach(item => {
        if (sub.check(item)) count++;
      });
      if (count > 0) total += count;
      return { label: sub.label, count };
    }).filter(s => s.count > 0);

    return calculatedSegments.map((s, i) => ({
      ...s,
      percentage: total > 0 ? (s.count / total) * 100 : 0,
      color: colors[i % colors.length]
    }));
  };

  const segments = getChartData();
  if (segments.length === 0) return null;

  return (
    <div className="sub-filter-progress-container mt-3 pt-3 border-top">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="text-secondary small fw-bold" style={{ fontSize: '0.65rem', letterSpacing: '1px' }}>
          DESGLOSE DE CATEGORÍA ({mapFilter.toUpperCase()})
        </span>
      </div>
      <div className="progress-bar-stack-premium">
        {segments.map((s, i) => (
          <CTooltip key={s.label} content={`${s.label}: ${s.count} (${s.percentage.toFixed(1)}%)`}>
            <div 
              className="progress-segment-premium" 
              style={{ 
                width: `${s.percentage}%`, 
                backgroundColor: s.color,
              }}
            >
              {s.percentage > 8 && <span className="segment-label-premium">{s.count}</span>}
            </div>
          </CTooltip>
        ))}
      </div>
      <div className="d-flex flex-wrap gap-x-4 gap-y-2 mt-2">
        {segments.map((s) => (
          <div key={s.label} className="d-flex align-items-center gap-2" style={{ fontSize: '0.7rem' }}>
            <div style={{ width: 10, height: 10, borderRadius: '3px', backgroundColor: s.color }}></div>
            <span className="text-muted fw-semibold">{s.label}:</span>
            <span className="text-dark fw-bold">{s.count}</span>
            <span className="text-primary-emphasis x-small">({s.percentage.toFixed(0)}%)</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubFilterProgressBar;
